<template>
  <div class="home">
    <section class="hero is-fullheight">
    <div class="container hero-body">
      <div class="columns is-centered is-vcentered">
        <div class="column is-full">
          <h2 class="title is-1">Meet Sidebr</h2>
          <h2 class="is-size-2">
            the <b>fastest</b> communication platform ever made
          </h2>
          <div v-if="!joinedWaitlist"
          class="field has-addons has-addons-centered">
            <div class="control">
              <input class="input is-large" v-model="email"
               type="email" placeholder="you@fasternow.com">
            </div>
            <div class="control">
              <a class="button is-large" v-on:click="submitForm()"
                v-bind:class="{ 'is-loading' : loading }"
               style="background-color: #6890F6; color: #FFF">
                Join The Waitlist
              </a>
            </div>
          </div>
          <h2 v-if="joinedWaitlist" class="is-size-3"
          style="color: #6890F6">
            You're in. We'll be in touch. Fast.
          </h2>
        </div>
      </div>
    </div>
  </section>
  <section class="hero is-fullheight">
    <div class="container hero-body">
      <div class="columns is-centered is-vcentered">
      <h2 class="is-size-2">
        <b>voice-first</b>, <b>seamless</b> calls that start with just <b>one click</b>
      </h2>
    <img class="vert-move" style="height: 400px; width: 400px"
    src="../assets/rocketAndCloud.png">
  </div>
  </div>
</section>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Home',
  data() {
    return {
      email: '',
      loading: false,
      joinedWaitlist: false,
    };
  },
  methods: {
    async submitForm() {
      this.loading = true;
      const data = {
        email: this.email,
      };
      const response = await this.$http.post('https://formspree.io/mnqggwnz', data);
      this.loading = false;
      this.joinedWaitlist = true;
      console.log(response);
    },
  },
};
</script>

<style>
img.vert-move {
    -webkit-animation: mover 1s infinite  alternate;
    animation: mover 1s infinite  alternate;
}
img.vert-move {
    -webkit-animation: mover 1s infinite  alternate;
    animation: mover 1s infinite  alternate;
}
@-webkit-keyframes mover {
    0% { transform: translateY(0); }
    100% { transform: translateY(-10px); }
}
@keyframes mover {
    0% { transform: translateY(0); }
    100% { transform: translateY(-10px); }
}
</style>
